<template>
  <section class="content">
      <div class="container-fluid">
          <div class="block-header">
              <h2>{{ nama }}</h2>
          </div>
          <div class="row clearfix">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="card">
                      <div class="header">
                          <h2>
                              {{ id_officer != null ? 'Edit' : 'Tambah' }} {{ nama }}
                          </h2>
                      </div>
                      <div class="body">
                          <form class="form-horizontal" v-on:submit.prevent="save">
                              <div class="row clearfix">
                                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                      <label for="deskripsi">Deskripsi</label>
                                  </div>
                                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                      <div class="form-group">
                                          <Ckeditor id="deskripsi" v-model="officer.deskripsi" :config="config"></Ckeditor>
                                      </div>
                                  </div>
                              </div>
                              <div class="row clearfix">
                                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                      <label for="foto">Foto</label>
                                  </div>
                                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                      <img v-if="officer.foto != null" v-bind:src="officer.foto" width="150px" alt="Foto" />
                                      <div class="form-group">
                                          <input id="foto" class="form-control" type="file" name="icon" @change="handleFile($event)" />
                                      </div>
                                  </div>
                              </div>
                              <div class="row clearfix">
                                  <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                      <button v-bind:disabled="isLoading" v-if="id_officer != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-waves.button>
                                          <span v-if="!isLoading"><i class="material-icons">save</i> Edit</span>
                                          <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                      </button>
                                      <button v-bind:disabled="isLoading" v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                          <span v-if="!isLoading"><i class="material-icons">save</i> Simpan</span>
                                          <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                      </button>
                                      <button @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                  </div>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
</template>

<script>
/* eslint-disable */
import Ckeditor from 'vue-ckeditor2'
import FormLine from '@/components/FormLine.vue'
import api from '@/helper/api'

export default {
  components: {FormLine, Ckeditor},
  name: 'ListNarasumber',
  data: function () {
    return {
      config: {
        toolbar: [
          { name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
          { name: 'morestuff', items: ['NumberedList', 'BulletedList'] },

          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] },
          { name: 'colors', items: ['TextColor'] },
          { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] },
          '/',
          { name: 'document', items: ['Source'] }
        ],
        height: 300
      },
      officer: {
        deskripsi: '',
        tipe: ''
      },
      icon: '',
      id_officer: '',
      link: '',
      nama: '',
      isLoading: false
    }
  },
  methods: {
    save () {
      console.log( "ini tipe", this.tipe)
      this.isLoading = true
      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
      var form = new FormData()
      form.append('file', this.icon)
      form.append('json', JSON.stringify(this.officer))
      api.post('/officer', form).then((result) => {
        if (result.data.code === 200) {
          this.$router.replace('/main/profile/' + this.link)
          this.$toastr.s('Tambah data berhasil')
        } else {
          var msg = 'Tambah data gagal'
          if (result.data.message !== '') msg = result.data.message
          this.$toastr.e(msg)
        }
        this.isLoading = false
      }).catch(e => {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi'
        if (e.response.data.message) msg = e.response.data.message
        this.$toastr.e(msg)
        this.isLoading = false
      })
    },
    update () {
      this.isLoading = true
      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
      var form = new FormData()
      form.append('file', this.icon)
      form.append('json', JSON.stringify(this.officer))
      api.post('/officer/' + this.id_officer, form).then((result) => {
        if (result.data.code === 200) {
          this.$router.replace('/main/profile/' + this.link)
          this.$toastr.s('Ubah data berhasil')
        }
        this.isLoading = false
      }).catch((ex) => {
        this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        this.isLoading = false
      })
    },
    getDetail () {
      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
      api.get('/officer/' + this.id_officer).then((result) => {
        this.officer = result.data
      }).catch((ex) => {
        this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
      })
    },
    handleFile (file) {
      this.icon = file.target.files[0]
    },
    checkRoute (route) {
      console.log(route.name)
      if (route.name === 'TambahPendiri' || route.name === 'EditPendiri') {
        this.officer.tipe = 1
        this.link = 'pendiri'
        this.nama = 'Pendiri'
      }
      if (route.name === 'TambahDewanPengawas' || route.name === 'EditDewanPengawas') {
        this.officer.tipe = 2
        this.link = 'dewan-pengawas'
        this.nama = 'Dewan Pengawas'
      }
      if (route.name === 'TambahPengurus' || route.name === 'EditPengurus') {
        this.officer.tipe = 3
        this.link = 'pengurus'
        this.nama = 'Pengurus'
      }
    }
  },
  mounted () {
    this.checkRoute(this.$route)
    this.id_officer = this.$route.params.id
    if (this.id_officer != null) {
      this.getDetail()
    }
  },
  '$route' (to, from) {
    this.checkRoute(to)
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/Profile/Pendiri/FormPendiri.vue